const AuthConstants = {
  LoginApiStatusSuccess: 'success',
  LoginApiStatusFailed: 'failed',
  LoginApiStatusLogout: 'logout'
}

export default AuthConstants
